export interface CallWordModel {
    text: string;
    counter: number;
    registered?: boolean;
    selected?: boolean;
    matched?: boolean;
}
